<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/foot-3active.png" class="avatar" @click="$router.push('/my')">
			<div class="search-bar">
				<img src="../assets/search-icon.png" class="search-icon">
				<input placeholder="请输入关键字进行搜索" class="search-input" @click="$router.push('/search')" />
			</div>
		</div>


		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="(item, index) in banner" :key="index" @click="toLink(item)">
        <img :src="item.cover" class="my-swipe-img">
      </van-swipe-item>
    </van-swipe>

		<div class="module">
			<div class="module-top">
				<ul class="tag-list">
					<li
              v-for="(item, index) in swiperCardList1"
              :key="index"
              :class="{active: swiperIndex1 === index }"
              @click="swiperIndex1 = index; $refs['swiper-card-1'].slideTo(index)"
          >
            {{ item.title }}
          </li>
				</ul>
			</div>
			<div class="module-bottom">
				<swiper-card
            ref="swiper-card-1"
            v-model="swiperIndex1"
            :list="swiperCardList1"
            img-key="img"
            link-key="link">
        </swiper-card>
			</div>
      <!-- 无数据时显示 -->
      <!-- <div class="normal-box-small">
        <img src="../assets/normal.png" >
        暂无数据
      </div> -->
		</div>

		<div class="module">
			<div class="module-top">
<!--				<span class="font-1">供应商</span>-->
				<ul class="tag-list">
          <li
              v-for="(item, index) in swiperCardList2"
              :key="index"
              :class="{active: swiperIndex2 === index }"
              @click="swiperIndex2 = index; $refs['swiper-card-2'].slideTo(index)"
          >
            {{ item.title }}
          </li>
        </ul>
			</div>
			<div class="module-bottom">
				<swiper-card
            ref="swiper-card-2"
            v-model="swiperIndex2"
            :list="swiperCardList2"
            img-key="img"
            link-key="link">
        </swiper-card>
			</div>
      <!-- 无数据时显示 -->
      <!-- <div class="normal-box-small">
        <img src="../assets/normal.png" >
        暂无数据
      </div> -->
		</div>

		<ul class="menu-list">
			<li>
				<img src="../assets/index-menu1.png" class="menu-icon">
				活动
			</li>
			<li>
				<img src="../assets/index-menu2.png" class="menu-icon">
				商品
			</li>
		</ul>

	</div>
</template>

<script>
import SwiperCard from '../components/swiper-card.vue'
import {ExpediteService} from "@/common/service";
	export default {
		name: 'index',
		components: {SwiperCard},
		data() {
			return {
				recommendTabId: 0,
				businessTabId: 0,

        swiperIndex1: 0,
        swiperCardList1: [{
          title: '视频',
          link: '/video',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2020-10-12%2F5f83b7c13d0b9.jpg&refer=http%3A%2F%2Fpic1.win4000.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=f6dca9186c83aac3518724a0e2b69470',
        },{
          title: '图文',
          link: '/image-text',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2020-09-10%2F5f59dace081de.jpg&refer=http%3A%2F%2Fpic1.win4000.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=c1d4f43930d54e21240b1a3d0c581853',
        },{
          title: '资料',
          link: '/information',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fe5%2Fee%2F39%2Fe5ee394171595fe762878968bf537f0c.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=6b9c1ea4048e15657fc09726b0d4a8d7',
        }],

        swiperIndex2: 0,
				swiperCardList2: [{
          title: '供应商',
          link: '',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2020-10-12%2F5f83b7c13d0b9.jpg&refer=http%3A%2F%2Fpic1.win4000.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=f6dca9186c83aac3518724a0e2b69470',
        },{
          title: '活动',
          link: '',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2020-09-10%2F5f59dace081de.jpg&refer=http%3A%2F%2Fpic1.win4000.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=c1d4f43930d54e21240b1a3d0c581853',
        },{
          title: '招聘',
          link: '',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fe5%2Fee%2F39%2Fe5ee394171595fe762878968bf537f0c.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=6b9c1ea4048e15657fc09726b0d4a8d7',
        },{
          title: '需求',
          link: '',
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2020-09-10%2F5f59dace081de.jpg&refer=http%3A%2F%2Fpic1.win4000.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657102696&t=c1d4f43930d54e21240b1a3d0c581853',
        }],

        // banner
        banner: [],
			};
		},
    mounted() {
      this.getBanner();
    },
    methods: {
      getBanner() {
        return ExpediteService.getBanner().then(({ data }) => {
          this.banner = data.list;
        });
      },

      toLink(item) {
        if (item.link) {
          location.href = item.link;
        }
      }
    }
  }
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 66px 15px 15px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 66px;
		display: flex;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.avatar {
		width: 31px;
		height: 31px;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 9px;
	}

	.search-bar {
		width: calc(100% - 75px);
		height: 38px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	/* 轮播 */
	.my-swipe >>> .van-swipe__indicator{
		width: 6px;
		height: 4px;
		border-radius: 2px;
	}
	.my-swipe >>> .van-swipe__indicator--active{
		width: 20px;
		height: 4px;
		border-radius: 2px;
	}
	.my-swipe {
		width: 100%;
		height: 150px;
		overflow: hidden;
		border-radius: 18px;
		margin-bottom: 14px;
	}

	.my-swipe .van-swipe-item {
		width: 100%;
		height: 150px;
		overflow: hidden;
		border-radius: 18px;
	}

	.my-swipe-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 18px;
	}

	.module {
		width: 100%;
		display: flex;
		flex-direction: column;
		border-radius: 18px;
		background-color: #FFFFFF;
		box-shadow: 0 1px 12px rgba(0, 0, 0, 0.12);
		margin-bottom: 14px;
		padding: 0 20px 20px;
		box-sizing: border-box;
	}

	.module-top {
		width: 100%;
		height: 34px;
		display: flex;
		align-items: center;
		overflow: auto;
		white-space: nowrap;
		margin-top: 8px;
		margin-bottom: 18px;
	}

	.tag-list {
    width: 100%;
		flex: 1;
    display: flex;
    justify-content: space-between;
    padding-bottom: 2px;
	}

	.tag-list>li {
		height: 34px;
		line-height: 34px;
		/*margin-right: 38px;*/
		display: inline-block;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tag-list>li:last-child {
		margin-right: 0;
	}

	.tag-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.tag-list>li.active::after {
    display: block;
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.font-1 {
		display: inline-block;
		color: #555555;
		font-size: 16px;
		margin-right: 38px;
	}

	.module-bottom {
		width: 100%;
	}

	.menu-list {
		width: 100%;
		height: 100px;
		display: flex;
		align-items: center;
		border-radius: 18px;
		background-color: #FFFFFF;
		box-shadow: 0 1px 12px rgba(0, 0, 0, 0.12);
		margin-bottom: 14px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.menu-list>li {
		flex: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		color: #222222;
		font-size: 15px;
		font-weight: 500;
	}

	.menu-list>li::after {
		content: "";
		width: 1px;
		height: 50px;
		background-color: #F4F4F4;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(0, -50%);
	}

	.menu-list>li:last-child::after {
		background-color: initial;
	}

	.menu-icon {
		height: 40px;
		margin-bottom: 4px;
	}
	.normal-box-small{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 50px 0;
	}
	.normal-box-small>img{
		width: 150px;
		margin-bottom: 9px;
	}
</style>
